export const ChevronDownSmall = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.6665 8.3335L9.41058 11.0776C9.73602 11.403 10.2637 11.403 10.5891 11.0776L13.3332 8.3335"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ChevronDownSmall
